export const ELEMENT_NOT_FOUND = -1;
export const CASINO_TAB_LOOTBOX = -2;
export const DEFAULT_CURRENCY = 'USD';
export const MAIN_CONTAINER_ID = 'main_container';
export const MINIMIZED_CONTAINER_ID = 'minimized_container';
export const GAMER_1 = 1;
export const GAMER_2 = 2;
export const STATUS_OPENED = 0;
export const REAL_MONEY = 'real_money';
export const DEMO_MONEY = 'demo_money';
export const PLAY_MONEY = 'play_money';
export const ARTIFACT_MONEY = 'artifact_money';
export const FIVE_SECONDS = 5000;
export const APP_INSTALL_ASKED = 'appInstallAsked';
export const BET_SLIP_POSITION_X_KEY = 'betSlipPositionX';
export const BET_SLIP_POSITION_Y_KEY = 'betSlipPositionY';
export const TURN_OFF_SCROLL_CLASS_NAME = 'body-overflow';
export const MIN_PLEDGE = 50;
export const MIN_COEF_CHANGING = 0;
export const MAX_COEF_CHANGING = 6;
export const MIN_DELAY_VALUE = 1;
export const MAX_DELAY_VALUE = 15;
export const INCUNATOR_GAME_ID = 'incubator_game_id';
export const ADULT_INCUBATOR_LIMIT = 200;
export const UNKNOWN_COUNTRY = 'xx';
export const PERCENT_75 = 75;
export const ASIDE_COUNT_LOOTBOX = 2;
export const DEFAULT = 'default';
export const SEC_IN_DAY = 86400;
export const ZERO_WIDTH_SPACE = '\u200B';
export const ARTICLE_PROMOTION_OLD_TYPE = 'promotions_old';
export const ARTICLE_PROMOTION_ARCHIVE_TYPE = 'promotions_archive';
export const StatsType = {
    EMPTY: 0,
    MONTHLY: 1,
    YEAR: 2
};
export const LANGUAGES = {
    EN: 'en',
    RU: 'ru'
};

export const ESC_KEY_CODE = 'Escape';
export const KEY_UP = 'ArrowUp';
export const KEY_DOWN = 'ArrowDown';
export const KEY_ENTER = 'Enter';

export const BetSlipFocus = {
    AMOUNT: 0,
    COEF: 1,
    WIN: 2
};
export const BET_SLIP_HEIGHT = 273;

export const DEFAULT_BETS = [
    '10',
    '20',
    '50'
];

export const REPEATABILITY_ONE_TIME = 'one_time';

export const USER_PROMOTION_DEPOSIT = 'userPromotionDeposit';
export const USER_PROMOTION_FRIEND = 'userPromotionFriend';
export const USER_PROMOTION_DISCONT = 'userPromotionDiscont';

export const PromoActionsWithBonuses = [
    'PromoActionPresent',
    'PromoActionOktoberfest',
    'PromoActionBeer',
    'PromoActionCocktail'
];

export const DEPOSIT_BONUS_TYPES = {
    BETS: 0,
    CASINO: 1,
    NO_BONUS: 2
};

export const MINUTES = {
    FIVE: 5,
    ONE: 1,
    TEN: 10,
    THREE: 3
};
